import LinearProgress from '@mui/material/LinearProgress'

import { ProgressContainer, ProgressLabel } from './index.styles'

interface LinearProgressWithLabelProps {
  label?: string
  orientation?: 'row' | 'column'
  value: number
}

const LinearProgressWithLabel = ({ label, value, orientation = 'row' }: LinearProgressWithLabelProps) => (
  <ProgressContainer $flexDirection={orientation}>
    <ProgressLabel variant="body1">{label}</ProgressLabel>
    <LinearProgress variant="determinate" value={value} />
  </ProgressContainer>
)

export default LinearProgressWithLabel
